module.exports = __webpack_public_path__ + "resources/img/img_LYN_pc_jp.d60f3f4c85a9dbbf93c488441361e2b4.png";